import React from 'react';

type MyState = {};
   
type MyPropsSingle = {
     click:any
     value:string
     priority?:string
     className?:string | null
}

export class ButtonSingle extends React.Component<MyPropsSingle, MyState>{
     render = () => 
          <div className="buttom"><button onClick={this.props.click} className={this.props.priority+" "+this.props.className}>{this.props.value}</button></div>
}



type MyPropsDouble = {
     next:MyPropsSingle,
     prev:MyPropsSingle,
}

export class ButtonDouble extends React.Component<MyPropsDouble, MyState>{
     render= () => 
          <div className="buttoDuals">
               <ButtonSingle priority="high" value={this.props.next.value} click={this.props.next.click} />
               <ButtonSingle priority="low" value={this.props.prev.value}  click={this.props.prev.click}/>
          </div>

}
